export default "__VITE_ASSET__BtV594u0__"